import GameSwitcher from './GameSwitcher'

export default GameSwitcher
